import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppHeader } from "~/components/layout/app-header";

export const Route = createFileRoute("/_auth/dashboard")({
  component: DashboardLayout,
});

function DashboardLayout() {
  const { user } = Route.useRouteContext();

  return (
    <>
      <AppHeader userName={user.name} userEmail={user.email} userImage={user.image} />
      <Outlet />
    </>
  );
}
